import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import EditSubscriptions from "../../components/SubscriptionPlan/EditSubscriptionPlan";


const EditSubscription = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Subscription  </h5><Breadcrumb title="Edit Subscription " /></div>


        {/* UsersListLayer */}
        <EditSubscriptions />

  

    </>
  );
};

export default EditSubscription; 